var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8Video1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6666 6.66663H5.33325V25.3333H26.6666V6.66663Z",
    fill: "#FFDD64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9999 4H25.3333V28H27.9999V4Z",
    fill: "#FFDD64"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9947 22.6666H25.3394V25.3333H27.9947V22.6666Z",
    fill: "#FC9F35"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9947 17.3334H25.3394V20H27.9947V17.3334Z",
    fill: "#FC9F35"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9947 12H25.3394V14.6667H27.9947V12Z",
    fill: "#FC9F35"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9947 6.66663H25.3394V9.33329H27.9947V6.66663Z",
    fill: "#FC9F35"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9886 20H25.3333V22.6667H27.9886V20Z",
    fill: "#FFECAA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9886 14.6666H25.3333V17.3333H27.9886V14.6666Z",
    fill: "#FFECAA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9886 9.33337H25.3333V12H27.9886V9.33337Z",
    fill: "#FFECAA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 4H4V28H6.66667V4Z",
    fill: "#FFDD64"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.65533 22.6666H4V25.3333H6.65533V22.6666Z",
    fill: "#FC9F35"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.65533 17.3334H4V20H6.65533V17.3334Z",
    fill: "#FC9F35"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.65533 12H4V14.6667H6.65533V12Z",
    fill: "#FC9F35"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.65533 20H4V22.6667H6.65533V20Z",
    fill: "#FFECAA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.65533 14.6666H4V17.3333H6.65533V14.6666Z",
    fill: "#FFECAA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.65533 9.33337H4V12H6.65533V9.33337Z",
    fill: "#FFECAA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.65533 6.66663H4V9.33329H6.65533V6.66663Z",
    fill: "#FC9F35"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6667 9.33337C18.746 9.33337 18 10.0794 18 11C18 11.9207 18.746 12.6667 19.6667 12.6667C20.5873 12.6667 21.3333 11.9207 21.3333 11C21.3333 10.0794 20.5873 9.33337 19.6667 9.33337Z",
    fill: "#FB348C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5141 14.6667L6.66675 25.3334H22.6667L14.5141 14.6667Z",
    fill: "#FB348C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 25.3334H25.3335L19.2188 17.3334L13.3335 25.3334Z",
    fill: "#FB348C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 25.3333H22.6668L17.9108 19.1113L13.3335 25.3333Z",
    fill: "#D72573"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Video1);
export default __webpack_public_path__ + "static/media/icons8-video-1.0ffd2c29f9a101ab680c6974827fdcfc.svg";
export { ForwardRef as ReactComponent };